<template>
  <div>
    <div class="tree-result-filter card" style="min-height: 120px;">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-9">
            <h5 class="h5" v-if="dataSelectedCategory && dataSelectedCategory.id > 0">
              {{ $t('processes.processing_activities.selected_process_label') }}:

              <span class="text-success">
                <router-link
                    :to="{ name: 'processes.view', params: { slug: dataSelectedCategory.slug }}"
                    qid="p-view-page-link"
                >
                  <font-awesome-icon icon="cube" class="text-success"/>
                  <span class="text-success" style="padding-left: 5px;">{{ dataSelectedCategory.name }}</span>
                </router-link>
              </span>
            </h5>
            <h5 style="margin-bottom:5px;" v-else>
              {{ $t('processes.processing_activities.all_activities_label') }}
            </h5>

            <div v-if="dataSelectedCategory && dataSelectedCategory.id > 0">
              <span v-if="dataSelectedCategory.users && dataSelectedCategory.users.length" class="mr-1" style="font-weight: 600;" qid="p-owners-list-label">
                {{ $t('table.owners') }}:
              </span>
              <span class="mr-2" v-for="user in dataSelectedCategory.users" qid="p-owners-list">
                <Avatar :object="user" size="xs"></Avatar>
              </span>

              <span v-if="dataSelectedCategory.tags_translated && dataSelectedCategory.tags_translated.length" class="mr-1" style="font-weight: 600;" qid="p-tags-list-label">
                {{ $t('table.tags') }}:
              </span>
              <span v-if="dataSelectedCategory.tags_translated && dataSelectedCategory.tags_translated.length" qid="p-tags-list">
                <span class="" v-for="tag in getReducedTags(dataSelectedCategory.tags_translated)" :title="tag.name_translated">
                  <font-awesome-icon icon="tag"/>
                  {{ tag.name_translated | truncate(35) }}
                </span>
                <span v-if="dataSelectedCategory.tags_translated.length > 3"
                      class="badge cursor-pointer"
                      @click="openTagsModal(dataSelectedCategory)"
                >
                  <font-awesome-icon icon="tags"/>
                  + {{ dataSelectedCategory.tags_translated.length - 3 }}
                </span>
              </span>

              <span v-if="dataSelectedCategory.process_group" class="mr-1" style="font-weight: 600;" qid="p-process-group-label">
                {{ $t('table.process_group') }}:
              </span>
              <span class="mr-2" qid="p-process-group" v-if="dataSelectedCategory.process_group">
                <span class="">
                  <font-awesome-icon icon="project-diagram"/>
                  {{ dataSelectedCategory.process_group ? dataSelectedCategory.process_group.name : '' }}
                </span>
              </span>
            </div>

            <div v-if="getClient.gdprModule && dataSelectedCategory && dataSelectedCategory.id > 0" style="padding-top: 5px;">
              <span class="mr-1" style="font-weight: 600;" qid="p-validation-purpose">
                {{ $t('processes.create.purpose_label') }}:
              </span>
              <span class="mr-2">
                <font-awesome-icon v-if="puLoading" icon="spinner" size="sm" class="fa-spin"/>
                <font-awesome-icon v-else-if="dataSelectedCategory.purpose && dataSelectedCategory.purpose.length" icon="check-circle" class="icon-success"/>
                <font-awesome-icon v-else icon="times-circle" class="icon-danger"/>
              </span>
              <span v-if="getClient.gdprAdvancedModule" class="mr-1" style="font-weight: 600;" qid="p-validation-legal-basis">
                {{ $t('processes.create.legal_basis_label') }}:
              </span>
              <span v-if="getClient.gdprAdvancedModule" class="mr-2">
                <font-awesome-icon v-if="lbLoading" icon="spinner" size="sm" class="fa-spin"/>
                <font-awesome-icon v-else-if="lbTableItems && lbTableItems.length" icon="check-circle" class="icon-success"/>
                <font-awesome-icon v-else icon="times-circle" class="icon-danger"/>
              </span>
              <span class="mr-1" style="font-weight: 600;" qid="p-validation-processing-role">
                {{ $t('activities.processing_role.title') }}:
              </span>
              <span class="mr-2">
                <font-awesome-icon v-if="prLoading" icon="spinner" size="sm" class="fa-spin"/>
                <font-awesome-icon v-else-if="prFound" icon="check-circle" class="icon-success"/>
                <font-awesome-icon v-else icon="times-circle" class="icon-danger"/>
              </span>
              <span class="mr-1" style="font-weight: 600;" qid="p-validation-data-subjects">
                {{ $t('activities.data_subject.title') }}:
              </span>
              <span class="mr-2">
                <font-awesome-icon v-if="dsLoading" icon="spinner" size="sm" class="fa-spin"/>
                <font-awesome-icon v-else-if="dsFound" icon="check-circle" class="icon-success"/>
                <font-awesome-icon v-else icon="times-circle" class="icon-danger"/>
              </span>
              <span class="mr-1" style="font-weight: 600;" qid="p-validation-retention-rules">
                {{ $t('activities.retention_rule.label') }}:
              </span>
              <span class="mr-2">
                <font-awesome-icon v-if="rrLoading" icon="spinner" size="sm" class="fa-spin"/>
                <font-awesome-icon v-else-if="rrFound" icon="check-circle" class="icon-success"/>
                <font-awesome-icon v-else icon="times-circle" class="icon-danger"/>
              </span>
            </div>
          </div>

          <div class="col-md-3 text-right" v-if="dataSelectedCategory && dataSelectedCategory.id > 0">
            <ProcessEditForm
              :object="dataSelectedCategory"
              class="float-right mb-2"
              style="margin-top: -3px;"
              buttonClass="btn-xs"
              @reloadContent="loadCategories($event)"
              v-if="isGranted([permissions.PROCESS_EDIT, permissions.PROCESS_EDIT_OWN], dataSelectedCategory)"
            ></ProcessEditForm>
            <span
              v-if="isGranted(permissions.ACTIVITY_CREATE)"
              qid="activity-create-button"
              class="float-right"
              style="margin-top: -3px;"
            >
              <ActivityCreateForm
                  @reloadContent="loadContent()"
                  buttonClass="btn-xs"
                  :process="dataSelectedCategory"
              ></ActivityCreateForm>
            </span>
          </div>
        </div>
      </div>
    </div>

    <ShowMoreModal
        :items="dataSelectedCategory.tags_translated"
        :show="showTagsModal"
        @closeViewModal="closeTagsModal"
        type="tags"
    ></ShowMoreModal>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import Avatar from '@/components/Avatar.vue';
  import ProcessEditForm from '@/views/Processes/ProcessEditForm.vue';
  import ActivityCreateForm from '@/views/Activities/ActivityCreateForm.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';

  export default {
    name: 'ProcessTopBar',
    data: function() {
      return {
        // loading: true,
        error: '',
        showTagsModal: false,
        buttonDisabled: false,

        puLoading: true,
        lbLoading: true,
        prLoading: true,
        dsLoading: true,
        rrLoading: true,
        itemToDelete: {},
        // copy of selectedCategory prop
        dataSelectedCategory: {},
        dataSelectedActivities: {},

        lbTableItems: [],

        prFound: false,
        dsFound: false,
        rrFound: false,
      }
    },
    props: {
      selectedCategory: {},
    },
    components: {
      Avatar,
      ProcessEditForm,
      ActivityCreateForm,
      ShowMoreModal,
    },
    watch: {
      selectedCategory: function (newValue, oldValue) {
        // Watching the prop and setting it's copy object which is used in this component
        if (newValue) {
          this.dataSelectedCategory = newValue

          if (this.getClient.gdprModule) {
            this.puLoading = true;
            this.lbLoading = true;
            this.prLoading = true;
            this.dsLoading = true;
            this.rrLoading = true;

            this.loadActivities()
          }
        } else {
          this.dataSelectedCategory = {}
        }
      },
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
    },
    methods: {
      getReducedTags(tags) {
        let reducedTags = []
        if (tags.length > 3) {
          reducedTags = _.cloneDeep(tags);
          reducedTags = reducedTags.slice(0, 3);
        } else {
          reducedTags = tags;
        }
        return reducedTags;
      },
      loadValidation() {
        this.puLoading = true;
        this.lbLoading = true;
        this.prLoading = true;
        this.dsLoading = true;
        this.rrLoading = true;

        this.puLoading = false;

        this.loadLegalBasis();
        this.checkProcessingRole();
        this.checkDataSubjects();
        this.checkRetentionRules();
      },
      openTagsModal(object) {
        this.selectedItem = object
        this.showTagsModal = true
      },
      closeTagsModal() {
        this.selectedItem = {}
        this.showTagsModal = false
      },
      loadCategories(response) {
        event.preventDefault();

        this.dataSelectedCategory = response
        this.$emit('forceSideFilterRenderComponent', this.dataSelectedCategory)
      },
      loadContent() {
        event.preventDefault();

        this.$emit('forceListUpdate', this.dataSelectedCategory)
      },
      loadActivities() {
        let self = this;

        if (this.dataSelectedCategory && this.dataSelectedCategory.slug) {
          piincHttp.get('processes/' + this.dataSelectedCategory.slug + '/activities', { params:
            {
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.dataSelectedActivities = response.data;
            self.loadValidation()
          }, function() {});
        }

      },
      loadLegalBasis() {
        let self = this;
        piincHttp.get('processes/' + this.dataSelectedCategory.slug + '/legal-basis', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.lbTableItems = response.data;
          self.lbLoading = false;
        }, function() {});
      },
      checkProcessingRole() {
        if (this.dataSelectedActivities && this.dataSelectedActivities.length) {
          this.prFound = true;

          this.dataSelectedActivities.forEach((value, index ) => {
            if (!value.gdpr.processing_role) {
              this.prFound = false;
            }
          });
        }else{
          this.prFound = false;
        }
        this.prLoading = false;
      },
      checkDataSubjects() {
        if (this.dataSelectedActivities && this.dataSelectedActivities.length) {
          let self = this;
          this.dsFound = true;

          this.dataSelectedActivities.forEach((value, index ) => {
            piincHttp.get('activities/' + value.slug + '/data-subjects', { params:
              {
                client: this.getClient.slug
              }
            }).then(function(response) {
              if (response.data.length == 0) {
                self.dsFound = false;
              }
              self.dsLoading = false;
            }, function() {});
          });
        }else{
          this.dsFound = false;
          this.dsLoading = false;
        }
      },
      checkRetentionRules() {
        if (this.dataSelectedActivities && this.dataSelectedActivities.length) {
          let self = this;
          this.rrFound = true;

          this.dataSelectedActivities.forEach((value, index ) => {
            piincHttp.get('activities/' + value.slug + '/retention-rules', { params:
              {
                client: this.getClient.slug
              }
            }).then(function(response) {
              if (response.data.length == 0) {
                self.rrFound = false;
              }
              self.rrLoading = false;
            }, function() {});
          });
        }else{
          this.rrFound = false;
          this.rrLoading = false;
        }
      },
    },
    created () {
      let self = this;
      // Create a copy of prop object to avoid directly mutating a prop (throws error)
      this.dataSelectedCategory = this.selectedCategory;

      if (this.dataSelectedCategory && this.dataSelectedCategory.slug) {
        this.loadActivities();
      }
    }
  }
</script>
